import { RoleId } from "lib/features/auth/types";

interface Role {
  id: RoleId;
  value: boolean;
  name: string;
  desc: string;
  selected: boolean;
}

export const roles: Role[] = [
  {
    id: 3,
    value: true,
    name: "Referee (Individual)",
    desc: "As a referee, you will be able to send referrals and make money.",
    selected: true,
  },
  {
    id: 4,
    value: false,
    name: "Business",
    desc: "As a business, you will be able to send and receive referrals.",
    selected: false,
  },
];
